import styled from "@emotion/styled";

import { ZIndexLayer } from "~/lib/styles";

export const Container = styled.div`
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  z-index: ${ZIndexLayer.GoogleOneTapSignIn};

  inline-size: min-content;
  margin-inline-start: auto;
  margin-inline-end: auto;
`;
